import { PolylineEdge, PolylineEdgeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';

class AuthorityRequirementView extends PolylineEdge {
  getEndArrow() {
    const { model } = this.props;
    const { stroke } = model.getEdgeStyle();
    return h('circle', {
      cx: -4,
      cy: 0,
      r: 3.5,
      fill: stroke || '#d48806',
      stroke: stroke || '#d48806',
    });
  }
}

class AuthorityRequirementModel extends PolylineEdgeModel {
  initEdgeData(data) {
    super.initEdgeData(data);
    this.text = { ...this.text, value: '', editable: false };
  }

  getEdgeStyle() {
    const style = super.getEdgeStyle();
    const t = getThemeStyle(this.graphModel, 'authorityRequirement');
    style.stroke = t.stroke || '#d48806';
    style.strokeWidth = t.strokeWidth || 1.5;
    style.strokeDasharray = '3,3';
    return style;
  }
}

export const AuthorityRequirement = {
  type: 'dmn:AuthorityRequirement',
  view: AuthorityRequirementView,
  model: AuthorityRequirementModel,
};
